"use client";

import Link from "next/link";
import { useWatch } from "react-hook-form";
import { Checkbox } from "@/components/ui/checkbox";
import { FieldError } from "@/components/ui/field";
import type { ContactFormApi } from "./contact-form-fields";
import { SMS_CONSENT_DISCLOSURE } from "@shared/legal/sms";
import { settingsHref } from "@shared/routing/settings-path";

const CONSENT_ERROR_ID = "contact-consent-error";

export function ContactFormConsent({ form }: { form: ContactFormApi }) {
  const [consent, smsConsent] = useWatch({ control: form.control, name: ["consent", "smsConsent"] });
  const consentError = form.formState.errors.consent;
  return (
    <div className="space-y-3">
      <div className="flex items-start gap-2.5">
        <Checkbox
          id="contact-consent"
          checked={consent === true}
          onCheckedChange={(checked) => form.setValue("consent", checked === true, { shouldValidate: true })}
          aria-invalid={!!consentError}
          aria-describedby={consentError ? CONSENT_ERROR_ID : undefined}
          className="mt-0.5"
        />
        <label htmlFor="contact-consent" className="text-xs text-muted-foreground">
          I agree to the{" "}
          <Link href="/terms-conditions" className="text-link underline hover:no-underline">
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link href="/privacy-policy" className="text-link underline hover:no-underline">
            Privacy Policy
          </Link>
        </label>
      </div>
      <FieldError id={CONSENT_ERROR_ID} errors={[consentError]} />
      <div className="flex items-start gap-2.5">
        <Checkbox
          id="contact-sms-consent"
          checked={smsConsent === true}
          onCheckedChange={(checked) => form.setValue("smsConsent", checked === true)}
          className="mt-0.5"
        />
        <label htmlFor="contact-sms-consent" className="text-xs text-muted-foreground">
          {SMS_CONSENT_DISCLOSURE}{" "}
          <Link href="/sms-terms" className="text-link underline hover:no-underline">SMS terms</Link>{" "}
          and{" "}
          <Link href="/privacy-policy" className="text-link underline hover:no-underline">Privacy Policy</Link>.
        </label>
      </div>
      <p className="text-xs text-muted-foreground">
        To activate order and photo request texts,{" "}
        <a href="/sign-in" className="text-link underline">sign in</a>{" "}
        and verify this mobile in <Link href={settingsHref("profile")} className="text-link underline">Settings</Link> before opting in.
      </p>
    </div>
  );
}
